export default __webpack_public_path__ + "assets/ogg/4a723b39d21889ee56e244d4129a5db7.ogg";